import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {




        $('.menu-item-has-children').on('click', function (e) {
            e.stopPropagation();
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });


        $('.gProjects__menuItem').on('click', function () {
            if (!$(this).hasClass('active')) {
                $(this).parents('.gProjects').find('.gProjects__menuItem, .gProjects__item').removeClass('active');
                $(this).addClass('active');
                $(this).parents('.gProjects').find('.gProjects__item.' + $(this).data('target')).addClass('active');
            }
        });






        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1600,
                autoplaySpeed: 4000,
                fade: true,
                cssEase: 'linear'
            });

        }



        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/twojeschody/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/twojeschody/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }


        $('.calc').calcPrice();


    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



$.fn.calcPrice = function () {
    // calc
    let calcMenu = $('.calcMenu__menu');
    let calcStep = 1;
    let stepHolder = $('.calc__step.stepNum_' + calcStep);
    let calcStepCount = $('.calc__step').length;

    if ($('.type_simple .calc__content').length > 0) {
        $('.type_simple .calc__content').slick({
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 3000,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 560,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

    }


    function moveToTopCalc() {
        $('html,body').animate({ scrollTop: ($('.calc__Steps').offset().top - 260) + 'px' }, 400);
    }

    function setActiveCalcMenu() {
        $('.calcMenu__menu li').removeClass(['active', 'checked', 'checked2']);
        $('.calcMenu__menu li').each(function (i) {

            if (i < calcStep - 1) {
                $(this).addClass('checked');
            } else if (i == calcStep - 1) {
                $(this).addClass('active');
            }
        });
        correctMenuSlider();
    }

    function changeStep() {
        $('.calc__step').removeClass('active');
        stepHolder.addClass('active');

        stepHolder.find('.calc__content.slick-initialized').slick('setPosition');
        setActiveCalcMenu();

        if (calcStep > 1) {
            $('.calc__navPrev').removeClass('disabled');
        } else {
            $('.calc__navPrev').addClass('disabled');
        }
        if (calcStep == calcStepCount) {
            $('.calc__navNext').addClass('disabled');
            $('.calc__navSend').addClass('show');
        } else {
            $('.calc__navNext').removeClass('disabled');
            $('.calc__navSend').removeClass('show');
        }

        $('.calc__navStepCount').text(calcStep);

    }

    function validateStep() {

        if (stepHolder.hasClass('type_simple')) {
            if (stepHolder.find('input[type=radio]:checked').length > 0 || stepHolder.find('select option:selected[value!=""]').length > 0) {
                return true;
            }
        }

        if (stepHolder.hasClass('type_dimensions')) {
            let validate = true;
            stepHolder.find('input:not(:disabled)').each(function (i) {
                if ($(this).val() == '') {
                    validate = false;
                    return false;
                }
            });
            return validate;
        }

        return false;
    }

    function changeStepTo(newStep) {
        if (newStep < calcStep) {
            //wstecz
            calcStep = newStep;
            stepHolder = $('.calc__step.stepNum_' + calcStep);
            changeStep();
            moveToTopCalc();
        } else {
            // w przód
            if (validateStep()) {
                //przechodzimy

                stepHolder.removeClass('error');

                calcStep = newStep;
                stepHolder = $('.calc__step.stepNum_' + calcStep);
                changeStep();

                moveToTopCalc();

            } else {
                // wyświetl alert
                stepHolder.addClass('error');
                moveToTopCalc();
            }
        }

    }


    function correctMenuSlider() {
        let active = $('.calcMenu__item.active');

        let left = active.offset().left - calcMenu.offset().left + (active.offset().left - (window.innerWidth / 2) - (active.width() / 2));
        left = calcMenu.offset().left + (window.innerWidth / 2) - active.offset().left - (active.width() / 2);


        left = left < 0 ? left : 0;
        calcMenu.css({ transform: 'translateX(' + (left) + 'px)' });

    }


    $('.calcMenu__item').click(function () {
        if ($(this).hasClass('checked')) {

            changeStepTo($(this).data('num'));
            correctMenuSlider();
        }


    });


    $('.calc__stepItemLabel input').change(function () {

        let elsInput = $(this).parents('.calc__content').find('.calc__stepItemOptionLabel input');
        elsInput.each(function (i) {
            this.checked = false;
            this.disabled = true;

        });
        $(this).parents('.calc__content').find('.calc__stepItem').removeClass('active');

        if ($(this).is(':checked')) {
            $(this).parents('.calc__stepItem').find(' .calc__stepItemOptions input').each(function (i) {

                this.checked = false;
                this.disabled = false;
                if (i == 0) {
                    this.checked = true;
                }
            });
            $(this).parents('.calc__stepItem').addClass('active');
            $(this).parents('.calc__stepItem').find('.calc__stepItamImage')[0].src = $(this).data('image');


        }
    });


    $('.calc__navNext').click(function () {
        changeStepTo(calcStep + 1);
    });
    $('.calc__navPrev').click(function () {
        if (calcStep > 1)
            changeStepTo(calcStep - 1);
    });

    $('.calc__navSend').click(function () {
        document.querySelector('.wpcf7-form input[type=submit]').click();
    });

    $('.wpcf7-form input[name=formRodo]').change(function () {
        if ($(this).is(':checked')) {
            $('.calc__navSend').removeClass('disabled');
        } else {
            $('.calc__navSend').addClass('disabled');
        }
    });



    $('.calc__stepItemOptions input').change(function () {
        if ($(this).is(':checked')) {
            $(this).parents('.calc__stepItem').find('.calc__stepItamImage')[0].src = $(this).data('image');
            $(this).parents('.calc__stepItem').find('.calc__stepItemLabel input').val($(this).val());
        }
    });
    $('.calc__stepItemOptions input[type=text]').focusout(function () {

        var content = $(this).parents('.calc__stepItem').find('.calc__stepItemLabel span').text();
        $(this).parents('.calc__stepItem').find('.calc__stepItemOptions input[type=text]').each(function () {
            content += ' - ' + $(this).parent().find('span').text() + ' ' + $(this).val() + '; ';
        });
        $(this).parents('.calc__stepItem').find('.calc__stepItemLabel input').val(content);
    });

    $('.calc__stepItemSelect').change(function () {
        $(this).parent().find('.calc__stepItemTextfield').removeClass('active').attr('disabled', 'disabled');

        $(this).parent().find('.calc__stepItemTextfield[data-id=' + $(this).find('option:checked').attr('data-id') + ']').addClass('active').removeAttr('disabled');
    });



    $('.calc__dimensionContent input[type=checkbox]').change(function () {
        if ($(this).is(':checked')) {
            $(this).parents('.calc__dimensionContent').find('#calcCFBWidth')[0].disabled = true;
        } else {
            $(this).parents('.calc__dimensionContent').find('#calcCFBWidth')[0].disabled = false;
        }
    });
    $('.calc__dimensionContent input[type=checkbox]').change();



    $('.calc__stepItemImageHolder').click(function () {
        $(this).parent().find('.calc__stepItemLabel input').click();
    });

    $('#calcDataForm input').change(function () {
        let calcData = $('#calcDataForm').serializeArray();
        let calcData2 = {};
        for (const key in calcData) {
            const item = calcData[key];
            calcData2[item.name] = item.value;
        }

        $('#calcData').val(JSON.stringify(calcData2));
    });

};